import { createContext } from "react";

export const AuthModalContext = createContext({
  openLoginModal: () => {},
});
